import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var DEFAULT_TTL = 5 * 60 * 1000;
export var InMemCache = /*#__PURE__*/function () {
  function InMemCache() {
    _classCallCheck(this, InMemCache);
  }
  return _createClass(InMemCache, null, [{
    key: "setData",
    value: function setData(_ref) {
      var key = _ref.key,
        response = _ref.response,
        ttl = _ref.ttl;
      this.cache.set(key, {
        ttl: Date.now() + (ttl || DEFAULT_TTL),
        response: response
      });
    }
  }, {
    key: "getData",
    value: function getData(key) {
      var _this$cache$get;
      return (_this$cache$get = this.cache.get(key)) === null || _this$cache$get === void 0 ? void 0 : _this$cache$get.response;
    }
  }, {
    key: "isValid",
    value: function isValid(key) {
      var item = this.cache.get(key);
      return Boolean(item) && Date.now() < ((item === null || item === void 0 ? void 0 : item.ttl) || 0);
    }
  }, {
    key: "getInflightRequest",
    value: function getInflightRequest(key) {
      return this.inFlightRequests.get(key);
    }
  }, {
    key: "setInflightRequest",
    value: function setInflightRequest(_ref2) {
      var key = _ref2.key,
        request = _ref2.request;
      this.inFlightRequests.set(key, request);
    }
  }, {
    key: "removeInflightRequest",
    value: function removeInflightRequest(key) {
      return this.inFlightRequests.delete(key);
    }

    // only for tests
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.cache.clear();
      this.inFlightRequests.clear();
    }
  }]);
}();
_defineProperty(InMemCache, "cache", new Map());
_defineProperty(InMemCache, "inFlightRequests", new Map());